import { render } from "./LimitLength.vue?vue&type=template&id=4a5745dc"
import script from "./LimitLength.vue?vue&type=script&lang=js"
export * from "./LimitLength.vue?vue&type=script&lang=js"
script.render = render

export default script